module.exports = __webpack_public_path__ + "img/infra6.bb89f580.png";